module.exports = "/_next/static/images/get-directions-arrow-fbc91377f7df8a27d63393ea06e6cc95.png";